import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { LOOKBOOK } from "./data";
import { useLang } from "./i18n";

const Frame = ({ l, className = "" }) => (
  <figure data-testid={`lookbook-frame-${l.n}`} className={`group relative shrink-0 overflow-hidden bg-[#0D0D0D] ${className}`}>
    <img src={l.src} alt={l.cap} loading="lazy" className="absolute inset-0 w-full h-full object-cover grayscale contrast-125 group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-1000" />
    <figcaption className="absolute inset-x-0 bottom-0 p-4 flex justify-between items-end bg-gradient-to-t from-black/80 to-transparent">
      <span className="f-disp uppercase text-2xl md:text-3xl text-white">{l.cap}</span>
      <span className="f-mono text-xs text-[#FF2A2A]">LB—{l.n}</span>
    </figcaption>
  </figure>
);

const Title = () => {
  const { t } = useLang();
  return (
  <div className="shrink-0 w-[80vw] md:w-[38vw] flex flex-col justify-end pr-6">
    <div className="f-mono text-xs tracking-[0.3em] text-[#FF2A2A] mb-4">(03) — {t("lb.kicker")}</div>
    <h2 className="f-goth text-[22vw] md:text-[11vw] leading-[0.8] text-[#F5F5F7]">Look<br />book</h2>
    <p className="mt-6 max-w-sm text-zinc-300 text-sm leading-relaxed">{t("lb.text")}</p>
  </div>
  );
};

export const Lookbook = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const x = useTransform(scrollYProgress, [0, 1], ["0%", "-72%"]);
  const sizes = ["h-[62vh] w-[44vh]", "h-[48vh] w-[72vh]", "h-[66vh] w-[50vh]", "h-[50vh] w-[76vh]", "h-[64vh] w-[44vh]", "h-[54vh] w-[42vh]", "h-[50vh] w-[74vh]"];

  return (
    <section id="lookbook" data-testid="lookbook-section" className="bg-[#050505]">
      <div ref={ref} className="hidden md:block relative h-[420vh]">
        <div className="sticky top-0 h-screen overflow-hidden flex items-center">
          <motion.div style={{ x }} className="flex items-end gap-6 pl-10 pr-[20vw]">
            <Title />
            {LOOKBOOK.map((l, i) => (
              <Frame key={l.n} l={l} className={`${sizes[i]} ${i % 2 ? "mb-[8vh]" : ""}`} />
            ))}
          </motion.div>
          <div className="absolute bottom-6 inset-x-10 h-px bg-white/15">
            <motion.div style={{ scaleX: scrollYProgress }} className="h-full bg-[#FF2A2A] origin-left" />
          </div>
        </div>
      </div>
      <div className="md:hidden py-24">
        <div className="px-5"><Title /></div>
        <div data-testid="lookbook-mobile-strip" className="mt-10 flex gap-3 overflow-x-auto snap-x snap-mandatory px-5 pb-4 og-noscrollbar" data-lenis-prevent>
          {LOOKBOOK.map((l) => <Frame key={l.n} l={l} className="snap-start h-[70vh] w-[78vw]" />)}
        </div>
      </div>
    </section>
  );
};
